import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createBet,
  createWager,
  getWager,
  getWagers,
  resolveWager,
} from "./bettingAPI";
import { BetCreation, Wager, WagerCreation, WagerResolution } from "./types";

export interface BettingState {
  wagers: Wager[];
  wager: Wager;
  status: "idle" | "loading" | "failed" | "succeeded";
}

const initialState: BettingState = {
  wagers: [],
  wager: null,
  status: "idle",
};

export const createWagerAsync = createAsyncThunk(
  "betting/createWager",
  async (wager: WagerCreation) => {
    return await createWager(wager);
  }
);

export const resolveWagerAsync = createAsyncThunk(
  "betting/createWager",
  async (wagerResolution: WagerResolution) => {
    return await resolveWager(wagerResolution);
  }
);

export const createBetAsync = createAsyncThunk(
  "betting/createBet",
  async (bet: BetCreation) => {
    return await createBet(bet);
  }
);

export const getWagersAsync = createAsyncThunk(
  "betting/getWagers",
  async (query: string) => {
    return await getWagers(query);
  }
);

export const getWagerAsync = createAsyncThunk(
  "betting/getWager",
  async (id: string) => {
    return await getWager(id);
  }
);

export const wagersSlice = createSlice({
  name: "betting",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getWagersAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getWagersAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.wagers = action.payload;
      })
      .addCase(getWagerAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getWagerAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.wager = action.payload;
      })
      .addCase(createWagerAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createWagerAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.wagers.unshift(action.payload);
      })
      .addCase(createWagerAsync.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(createBetAsync.fulfilled, (state, action) => {
        state.wager.bets.push(action.payload);
      })
      .addCase(createBetAsync.rejected, (state, action) => {});
  },
});

// export const {} = wagersSlice.actions;

export default wagersSlice.reducer;
